import { useTranslation } from "react-i18next";

const ConfirmationDialog = ({ title, handleConfirm, handleCancel, showDialog, primary}) => {
    const { t } = useTranslation();
    return (
        <>
            {/* Backdrop */}
            <div className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ${showDialog ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}></div>
            {/* Dialog Container */}
            <div className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-300 ${showDialog ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'}`}>
                <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 transform transition-all duration-300">
                    {/* Warning Icon */}
                    <div className="flex justify-center pt-6">
                        <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
                            <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                            </svg>
                        </div>
                    </div>
                    {/* Content */}
                    <div className="p-6 pt-4">
                        <p className="text-base font-bold text-gray-700 text-center leading-relaxed mb-6">{title}</p>
                        {/* Additional Info */}
                        <div className="bg-blue-50 border border-blue-200 rounded-md p-2 mb-6">
                            <div className="flex items-center justify-center">
                                <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center mr-2 flex-shrink-0" style={{ lineHeight: 1 }}>
                                    <span className="text-white text-xs font-bold" style={{ lineHeight: 1 }}>i</span>
                                </div>
                                <p className="text-sm text-blue-800 mb-0">{t('This action will start a new conversation and cannot be undone.')}</p>
                            </div>
                        </div>
                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row w-full gap-0">
                            <button 
                                onClick={handleCancel}
                                className="flex items-center justify-center px-4 h-12 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 w-full sm:w-auto sm:flex-1 mb-2 sm:mb-0 sm:mr-2"
                            >
                                <svg className="w-5 h-5 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                </svg>
                                <span className="sm:inline">{t('Keep Conversation')}</span>
                            </button>
                            <button 
                                onClick={handleConfirm}
                                className="flex items-center justify-center px-4 h-12 text-sm font-medium text-white rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 w-full sm:w-auto sm:flex-1 border"
                                style={{ backgroundColor: primary || '#3B82F6' }}
                                onMouseEnter={e => { e.target.style.backgroundColor = primary || '#2563EB'; }}
                                onMouseLeave={e => { e.target.style.backgroundColor = primary || '#3B82F6'; }}
                            >
                                <svg className="w-5 h-5 mr-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                <span className="sm:inline">{t('Clear & Start New')}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ConfirmationDialog;